import { IBaseVraagboomResultaat } from './base.vraagboom.resultaat';

export class VraagboomMultiResultaat implements IBaseVraagboomResultaat {
  resultaten: Map<string, IBaseVraagboomResultaat> = new Map<string, IBaseVraagboomResultaat>();
}
